export type BookingWizardEnforcementModeKind = "deny" | "warning_limited" | "warning_unlimited" | "unknown";

export interface MultiplePieceQuantityDecision {
  action: "next" | "end";
  quantityError: string | null;
}

const MULTIPLE_PIECE_QUANTITY_OVER_REMAINING_MSG = "Quantity is over the remaining spots";

/** FR-AV131-012–015 — quantity vs remaining spots on multipiece equipment step. */
export function resolveMultiplePieceQuantityDecision(
  quantity: number,
  remainingSpots: number,
  enforcementMode: BookingWizardEnforcementModeKind,
  graceInclusiveMaxQuantity: number,
): MultiplePieceQuantityDecision {
  if (!Number.isFinite(quantity) || quantity <= 0) {
    return { action: "next", quantityError: null };
  }
  if (quantity <= remainingSpots) {
    return { action: "next", quantityError: null };
  }
  if (enforcementMode === "warning_unlimited") {
    return { action: "next", quantityError: null };
  }
  if (enforcementMode === "warning_limited") {
    if (quantity <= graceInclusiveMaxQuantity) {
      return { action: "next", quantityError: null };
    }
    return { action: "end", quantityError: null };
  }
  if (enforcementMode === "deny") {
    return { action: "end", quantityError: MULTIPLE_PIECE_QUANTITY_OVER_REMAINING_MSG };
  }
  return { action: "end", quantityError: null };
}

/** Strip trailing `(locationId)` suffix from list filter labels for schedule display. */
export function stripBookingWizardLocationLabel(label: string): string {
  return label.replace(/\s*\(\d+\)\s*$/, "").trim() || label;
}
